import { DOCUMENT } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostListener, inject } from '@angular/core';
import { MatDrawerMode } from '@angular/material/sidenav';
import { Store } from '@ngrx/store';
import { filter } from 'rxjs';
import { selectSelectedCompany, selectUserProfile } from 'src/app/auth/store/auth.selectors';
import { getRouterOutletState } from '../../shared/helpers/utility';
import { SidenavService } from '../sidenav/sidenav.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomeComponent {
  private _document = inject(DOCUMENT);

  sidenavMode = this._getSidenavMode();

  getState = getRouterOutletState;

  user$ = this.store.select(selectUserProfile).pipe(filter(u => u !== undefined && u !== null));
  company$ = this.store
    .select(selectSelectedCompany)
    .pipe(filter(c => c !== undefined && c !== null));

  constructor(public readonly sidenavService: SidenavService, public store: Store) {}

  @HostListener('window:resize', ['$event'])
  private _onWindowResize() {
    this.sidenavMode = this._getSidenavMode();
  }

  private _getSidenavMode(): MatDrawerMode {
    return this._document.body.clientWidth >= this._document.body.clientHeight ? 'side' : 'over';
  }
}
